export default __webpack_public_path__ + "static/media/add.e95f7493.svg";